/**
 * @format
 */

function showLocation() {
  console.log('showLocation');
}

export default {};
export { showLocation };
